import {Component, OnInit, OnDestroy} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AuthenticationService} from "../../shared/services/authentication.service";
import {UserModel} from "../../shared/models/user/user.model";
import {CdnService} from '../../shared/services/cdn.service';
import {Http} from '@angular/http';

@Component({
    selector: 'header-main',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    public show: boolean = false;
    public user: UserModel;
    public avatarUrl: string;
    public status: string = 'online';
    public autosuggest = [];
    private userChangeSubscription;
    private backendUrl: string;

    constructor(private authService: AuthenticationService,
                private cdn: CdnService,
                private http: Http) {
        this.getUser();
        this.backendUrl = environment.backendUrl;
    }

    toggle() {
        this.show = !this.show
    }

    ngOnInit() {
        this.userChangeSubscription = this.authService.userChange$.subscribe(
            (user) => {
                this.getUser();
            }
        );
    }

    ngOnDestroy() {
        this.userChangeSubscription.unsubscribe();
    }

    getUser() {
        this.user = this.authService.getUser();
        this.avatarUrl = (this.user && this.user.avatar) ? this.cdn.getImageUrl(this.user.avatar.id, this.user.avatar.filename) : "/assets/images/avatar.gif";
    }
} 


// WEBPACK FOOTER //
// /code/frontend/src/app/main/header/header.component.ts